export function trackEvent(eventData) {
  if (!eventData) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(eventData)
}
